/* Run24 — PDP (selector de variantes, sticky ATC, live pill, FAQ,
   favoritos y kit cross-sell).

   ATC: se reutiliza el web component <product-form> de Dawn
   (assets/product-form.js) — este archivo solo mantiene actualizado el
   input[name="id"] del form y el estado del botón. El fetch a
   /cart/add y la apertura del cart drawer los hace product-form.js.

   Selector de variantes: implementación propia (no variant-selects de
   Dawn) — el markup del prototipo es un grid de botones, no selects, y
   no necesitamos el re-render por sección de product-info.js. */

(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatMoney(cents, currency) {
    var amount = cents / 100;
    var hasDecimals = cents % 100 !== 0;
    try {
      return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: currency || 'MXN',
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: hasDecimals ? 2 : 0,
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(hasDecimals ? 2 : 0);
    }
  }

  /* ────────────────────────────────────────────────────────────
     1 · Selector de variantes + sticky ATC
     ──────────────────────────────────────────────────────────── */
  function initProduct() {
    var root = document.querySelector('[data-r24-product]');
    var dataEl = document.querySelector('[data-r24-product-json]');
    if (!root || !dataEl || root.dataset.r24Init === 'true') return;
    root.dataset.r24Init = 'true';

    var config;
    try {
      config = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var variants = config.variants || [];
    var sizeIdx = config.sizeIndex;
    var colorIdx = config.colorIndex;
    var strings = config.strings || {};
    var currency = config.currency;

    var colorButtons = Array.prototype.slice.call(root.querySelectorAll('[data-r24-color]'));
    var sizeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-r24-size]'));
    var colorNameEl = root.querySelector('[data-r24-color-name]');
    var priceEl = root.querySelector('[data-r24-price]');
    var compareEl = root.querySelector('[data-r24-compare]');
    var skuEl = root.querySelector('[data-r24-sku]');
    var stickyLineEl = document.querySelector('[data-r24-sticky-line]');
    var mainImg = root.querySelector('.r24-pdp__gallery .r24-gimg--main img');
    var productForm = root.querySelector('product-form form');
    var idInput = productForm ? productForm.querySelector('input[name="id"]') : null;
    var atcButton = productForm ? productForm.querySelector('button[type="submit"]') : null;
    var atcText = atcButton ? atcButton.querySelector('[data-r24-atc-text]') : null;
    var kitMain = document.querySelector('[data-r24-kit-main]');
    var kitMainPrice = document.querySelector('[data-r24-kit-main-price]');

    var selectedColor = null;
    var selectedSize = null;
    colorButtons.forEach(function (btn) {
      if (btn.classList.contains('r24-color--on')) selectedColor = btn.dataset.r24Color;
    });
    sizeButtons.forEach(function (btn) {
      if (btn.classList.contains('r24-size--on')) selectedSize = btn.dataset.r24Size;
    });

    function matchesSelection(variant) {
      if (colorIdx >= 0 && selectedColor !== null && variant.options[colorIdx] !== selectedColor) return false;
      if (sizeIdx >= 0 && selectedSize !== null && variant.options[sizeIdx] !== selectedSize) return false;
      return true;
    }

    function currentVariant() {
      for (var i = 0; i < variants.length; i++) {
        if (matchesSelection(variants[i])) return variants[i];
      }
      return null;
    }

    function refreshSizeAvailability() {
      if (sizeIdx < 0) return;
      sizeButtons.forEach(function (btn) {
        var size = btn.dataset.r24Size;
        var available = variants.some(function (v) {
          if (v.options[sizeIdx] !== size) return false;
          if (colorIdx >= 0 && selectedColor !== null && v.options[colorIdx] !== selectedColor) return false;
          return v.available;
        });
        btn.disabled = !available;
      });
    }

    function updateStickyLine(variant) {
      if (!stickyLineEl) return;
      var parts = [formatMoney(variant ? variant.price : 0, currency)];
      if (selectedColor) parts.push(selectedColor);
      if (selectedSize) parts.push((strings.size || 'Talla') + ' ' + selectedSize);
      stickyLineEl.textContent = parts.join(' · ');
    }

    function updateGallery(variant) {
      if (!mainImg || !variant || !variant.featured_image || !variant.featured_image.src) return;
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = variant.featured_image.src;
      if (variant.featured_image.alt) mainImg.alt = variant.featured_image.alt;
    }

    function updateUrl(variant) {
      if (!variant || !window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {
        /* noop */
      }
    }

    /* Disponibilidad de pickup por sucursal (pivote 2026-09-24): Shopify ya
       solo tiene una location con el total, así que la verdad por sucursal se
       consulta al backend (que lee RICS) UNA vez por producto — la respuesta
       trae todas las tallas de ambas sucursales y el cambio de talla se
       repinta local, sin más red. Backend caído o sin datos → fila oculta. */
    var PICKUP_ENDPOINT = 'https://us-central1-run24-da5be.cloudfunctions.net/run24Backend/public/stock-sucursales';
    var PICKUP_SUCURSALES = [
      { id: 'mirador', nombre: 'Sucursal Mirador (Monterrey)' },
      { id: 'arboleda', nombre: 'Sucursal Arboleda (San Pedro)' },
    ];
    var pickupStock = null; /* null = sin pedir, false = falló/sin datos, objeto = respuesta */
    var pickupFetch = null;

    function fetchPickupStock(sku) {
      if (!pickupFetch) {
        pickupFetch = fetch(PICKUP_ENDPOINT + '?sku=' + encodeURIComponent(sku))
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            pickupStock = data && data.disponible && data.sucursales ? data : false;
          })
          .catch(function () { pickupStock = false; });
      }
      return pickupFetch;
    }

    function paintPickup(variant) {
      var box = document.querySelector('[data-r24-pickup-real]');
      if (!box) return;
      if (!pickupStock || !variant) {
        box.hidden = true;
        return;
      }
      var talla = sizeIdx >= 0 && variant.options ? String(variant.options[sizeIdx]).trim().toLowerCase() : 'unica';
      var disponibles = PICKUP_SUCURSALES.filter(function (s) {
        var suc = pickupStock.sucursales[s.id];
        if (!suc || !suc.tallas) return false;
        return Object.keys(suc.tallas).some(function (t) {
          return String(t).trim().toLowerCase() === talla && suc.tallas[t] > 0;
        });
      });
      var icon = box.querySelector('[data-r24-pickup-icon]');
      var badge = box.querySelector('[data-r24-pickup-badge]');
      var list = box.querySelector('[data-r24-pickup-stores]');
      var sub = box.querySelector('[data-r24-pickup-sub]');
      if (disponibles.length) {
        if (icon) icon.classList.add('r24-pickup__icon--on');
        if (badge) badge.hidden = false;
        if (list) {
          list.innerHTML = '';
          disponibles.forEach(function (s) {
            var li = document.createElement('li');
            var strong = document.createElement('strong');
            strong.textContent = s.nombre;
            var span = document.createElement('span');
            span.textContent = 'normalmente está lista en 24 horas';
            li.appendChild(strong);
            li.appendChild(span);
            list.appendChild(li);
          });
          list.hidden = false;
        }
        if (sub) sub.textContent = 'Sin costo · Te avisamos por correo cuando esté lista.';
      } else {
        if (icon) icon.classList.remove('r24-pickup__icon--on');
        if (badge) badge.hidden = true;
        if (list) list.hidden = true;
        if (sub) sub.textContent = 'Esta talla no está en tienda para recoger — te la enviamos a domicilio.';
      }
      box.hidden = false;
    }

    function updatePickup(variant) {
      var box = document.querySelector('[data-r24-pickup-real]');
      if (!box || !variant) return;
      if (pickupStock !== null) {
        paintPickup(variant);
        return;
      }
      var sku = variant.sku || box.dataset.sku;
      if (!sku) {
        box.hidden = true;
        return;
      }
      fetchPickupStock(sku).then(function () { paintPickup(currentVariant()); });
    }

    function render() {
      var variant = currentVariant();

      if (idInput) {
        if (variant) {
          idInput.value = variant.id;
          idInput.disabled = !variant.available;
        } else {
          idInput.disabled = true;
        }
      }

      if (atcButton && atcText) {
        if (!variant) {
          atcButton.disabled = true;
          atcText.textContent = strings.unavailable || 'No disponible';
        } else if (!variant.available) {
          atcButton.disabled = true;
          atcText.textContent = strings.soldOut || 'Agotado';
        } else {
          atcButton.disabled = false;
          atcButton.removeAttribute('aria-disabled');
          atcText.textContent = strings.add || 'Agregar a la bolsa';
        }
      }

      if (priceEl && variant) priceEl.textContent = formatMoney(variant.price, currency);
      if (compareEl) {
        if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price, currency);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      /* SKU para staff: sigue a la variante seleccionada (talla/color). */
      if (skuEl) {
        if (variant && variant.sku) {
          skuEl.textContent = 'SKU ' + variant.sku;
          skuEl.hidden = false;
        } else {
          skuEl.hidden = true;
        }
      }

      if (variant && kitMain) {
        kitMain.dataset.price = variant.price;
        if (kitMainPrice) kitMainPrice.textContent = formatMoney(variant.price, currency);
        document.dispatchEvent(new CustomEvent('r24:kit:refresh'));
      }

      updateStickyLine(variant);
      updateGallery(variant);
      updateUrl(variant);
      updatePickup(variant);
    }

    colorButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectedColor = btn.dataset.r24Color;
        colorButtons.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('r24-color--on', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        if (colorNameEl) colorNameEl.textContent = selectedColor;
        refreshSizeAvailability();
        render();
      });
    });

    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        selectedSize = btn.dataset.r24Size;
        sizeButtons.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('r24-size--on', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        render();
      });
    });

    /* Primera pintada del pickup: el markup del server llega oculto y sin
       datos — se piden aquí (una sola vez por producto). */
    updatePickup(currentVariant());

    /* ── Sticky CTA: aparece cuando el buy box sale del viewport
       (scroll listener como el prototipo — IO puede saltarse el cruce
       en scrolls rápidos) ── */
    var sticky = document.querySelector('[data-r24-stickycta]');
    var buyBox = root.querySelector('.r24-pdp__actions');
    if (sticky && buyBox) {
      var stickyTicking = false;
      var updateSticky = function () {
        stickyTicking = false;
        var passed = buyBox.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('r24-stickycta--on', passed);
        sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
      };
      window.addEventListener(
        'scroll',
        function () {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        },
        { passive: true }
      );
      updateSticky();
    }

    var stickyAtc = document.querySelector('[data-r24-sticky-atc]');
    if (stickyAtc && productForm) {
      stickyAtc.addEventListener('click', function () {
        if (typeof productForm.requestSubmit === 'function') productForm.requestSubmit();
        else productForm.submit();
      });
    }

    var scrollWaitlist = document.querySelector('[data-r24-scroll-waitlist]');
    var waitlist = document.querySelector('[data-r24-waitlist]');
    if (scrollWaitlist && waitlist) {
      scrollWaitlist.addEventListener('click', function () {
        waitlist.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
        var input = waitlist.querySelector('input[type="email"]');
        if (input) input.focus({ preventScroll: true });
      });
    }
  }

  /* ────────────────────────────────────────────────────────────
     2 · Live activity (pill rotativa de social proof)
     ──────────────────────────────────────────────────────────── */
  function initLive() {
    document.querySelectorAll('[data-r24-live]').forEach(function (pill) {
      if (pill.dataset.r24Init === 'true' || reducedMotion) return;
      pill.dataset.r24Init = 'true';
      var dataEl = pill.querySelector('[data-r24-live-data]');
      var msgEl = pill.querySelector('[data-r24-live-msg]');
      if (!dataEl || !msgEl) return;
      var messages;
      try {
        messages = JSON.parse(dataEl.textContent).filter(function (m) {
          return m && m.length;
        });
      } catch (e) {
        return;
      }
      if (messages.length < 2) return;
      var i = 0;
      setInterval(function () {
        i = (i + 1) % messages.length;
        var clone = msgEl.cloneNode(false);
        clone.textContent = messages[i];
        msgEl.parentNode.replaceChild(clone, msgEl);
        msgEl = clone;
      }, 3800);
    });
  }

  /* ────────────────────────────────────────────────────────────
     3 · FAQ: al abrir un item se cierran los demás
     ──────────────────────────────────────────────────────────── */
  function initFaq() {
    document.querySelectorAll('[data-r24-faq]').forEach(function (faq) {
      if (faq.dataset.r24Init === 'true') return;
      faq.dataset.r24Init = 'true';
      faq.querySelectorAll('.r24-faq__item').forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          faq.querySelectorAll('.r24-faq__item[open]').forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  }

  /* ────────────────────────────────────────────────────────────
     4 · Favoritos (localStorage)
     ──────────────────────────────────────────────────────────── */
  function readFavs() {
    try {
      return JSON.parse(window.localStorage.getItem('r24:favs')) || [];
    } catch (e) {
      return [];
    }
  }

  function initFavs() {
    var buttons = document.querySelectorAll('[data-r24-fav]');
    if (!buttons.length) return;
    var favs = readFavs();

    buttons.forEach(function (btn) {
      if (btn.dataset.r24Init === 'true') return;
      btn.dataset.r24Init = 'true';
      var handle = btn.dataset.productHandle;
      var textEl = btn.querySelector('[data-r24-fav-text]');

      function paint(on) {
        btn.classList.toggle('is-on', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (textEl) textEl.textContent = on ? 'Guardado en favoritos' : 'Guardar en favoritos';
      }

      paint(favs.indexOf(handle) !== -1);

      btn.addEventListener('click', function () {
        var current = readFavs();
        var i = current.indexOf(handle);
        var on = i === -1;
        if (on) current.push(handle);
        else current.splice(i, 1);
        try {
          window.localStorage.setItem('r24:favs', JSON.stringify(current));
        } catch (e) {
          /* noop */
        }
        document.querySelectorAll('[data-r24-fav][data-product-handle="' + handle + '"]').forEach(function (other) {
          other.classList.toggle('is-on', on);
          other.setAttribute('aria-pressed', on ? 'true' : 'false');
          var t = other.querySelector('[data-r24-fav-text]');
          if (t) t.textContent = on ? 'Guardado en favoritos' : 'Guardar en favoritos';
        });
      });
    });
  }

  /* ────────────────────────────────────────────────────────────
     5 · Cross-sell "Completa tu kit"
     Los items llegan async vía <product-recommendations> (global.js);
     se observa el nodo y se recalcula el total al vuelo.
     ──────────────────────────────────────────────────────────── */
  function initCross() {
    var section = document.querySelector('[data-r24-cross]');
    if (!section || section.dataset.r24Init === 'true') return;
    section.dataset.r24Init = 'true';

    var currency = section.dataset.currency;
    var discountPct = parseInt(section.dataset.discountPct, 10) || 0;
    var totalBox = section.querySelector('[data-r24-kit-total]');
    var countEl = section.querySelector('[data-r24-kit-count]');
    var priceElK = section.querySelector('[data-r24-kit-price]');
    var fullEl = section.querySelector('[data-r24-kit-full]');
    var saveEl = section.querySelector('[data-r24-kit-save]');
    var addBtn = section.querySelector('[data-r24-kit-add]');
    var mainEl = section.querySelector('[data-r24-kit-main]');

    function items() {
      return Array.prototype.slice.call(section.querySelectorAll('[data-r24-kit-item]'));
    }

    function refresh() {
      var list = items();

      // No duplicar el producto que se está viendo (posible con la colección de respaldo)
      list = list.filter(function (item) {
        var url = (item.dataset.url || '').split('?')[0];
        if (url && window.location.pathname.indexOf(url) === 0) {
          item.remove();
          return false;
        }
        return true;
      });

      if (!list.length) {
        section.hidden = true;
        return;
      }
      section.hidden = false;
      if (totalBox) totalBox.hidden = false;

      var selected = list.filter(function (item) {
        return item.dataset.selected === 'true';
      });
      var total = parseInt(mainEl ? mainEl.dataset.price : '0', 10) || 0;
      selected.forEach(function (item) {
        total += parseInt(item.dataset.price, 10) || 0;
      });
      // Redondear el ahorro a pesos completos (como el prototipo).
      // Sin complementos no hay kit: el tenis solo va a precio normal.
      var save =
        selected.length > 0 && discountPct > 0 ? Math.round((total * discountPct) / 100 / 100) * 100 : 0;
      var count = 1 + selected.length;

      if (countEl) {
        countEl.textContent = 'Total del kit (' + count + ' ' + (count === 1 ? 'producto' : 'productos') + ')';
      }
      if (priceElK) priceElK.textContent = formatMoney(total - save, currency);
      if (fullEl) {
        fullEl.hidden = save <= 0;
        if (save > 0) fullEl.textContent = formatMoney(total, currency);
      }
      if (saveEl) {
        saveEl.hidden = save <= 0;
        if (save > 0) saveEl.textContent = 'Ahorras ' + formatMoney(save, currency);
      }
      if (addBtn) addBtn.disabled = false;
    }

    // Selector de talla por item: el select manda sobre data-variant-id/price.
    section.addEventListener('change', function (evt) {
      var sel = evt.target.closest('[data-r24-kit-size]');
      if (!sel) return;
      var item = sel.closest('[data-r24-kit-item]');
      if (!item) return;
      var opt = sel.options[sel.selectedIndex];
      item.dataset.variantId = opt.value;
      item.dataset.price = opt.dataset.price || item.dataset.price;
      var priceEl = item.querySelector('[data-r24-kit-item-price]');
      if (priceEl && opt.dataset.price) priceEl.textContent = formatMoney(parseInt(opt.dataset.price, 10), currency);
      refresh();
    });

    section.addEventListener('click', function (evt) {
      if (evt.target.closest('[data-r24-kit-size]')) return; // elegir talla no toggle-a el item
      var item = evt.target.closest('[data-r24-kit-item]');
      if (!item || !section.contains(item)) return;
      var on = item.dataset.selected !== 'true';
      item.dataset.selected = on ? 'true' : 'false';
      item.setAttribute('aria-pressed', on ? 'true' : 'false');
      var state = item.querySelector('[data-r24-kit-item-state]');
      if (state) {
        state.classList.toggle('r24-cross__item__add--on', on);
        state.textContent = on ? '✓ Incluido' : '+ Agregar';
      }
      refresh();
    });

    // Los items ahora son div[role=button] (por el select de talla interno):
    // Enter/Espacio deben seguir toggle-ando como cuando eran <button>.
    section.addEventListener('keydown', function (evt) {
      if (evt.key !== 'Enter' && evt.key !== ' ') return;
      var item = evt.target.closest('[data-r24-kit-item]');
      if (!item || evt.target.closest('[data-r24-kit-size]')) return;
      evt.preventDefault();
      item.click();
    });

    document.addEventListener('r24:kit:refresh', refresh);

    // Observar SOLO el nodo de recomendaciones (los items llegan async).
    // Nunca la sección completa: refresh() escribe textContent en los
    // totales y eso re-dispararía el observer en loop infinito.
    var recEl = section.querySelector('product-recommendations');
    if (recEl && 'MutationObserver' in window) {
      var mo = new MutationObserver(refresh);
      mo.observe(recEl, { childList: true, subtree: true });
    }
    refresh();

    // La sección arranca [hidden] (display:none), así que el
    // IntersectionObserver interno de <product-recommendations>
    // (global.js) nunca dispara el fetch. Observamos el wrapper
    // visible (.r24-pdpsec) como sentinel y forzamos la carga al
    // acercarse al viewport — mismo rootMargin que Dawn.
    if (recEl && !recEl.querySelector('[data-r24-kit-item]')) {
      var loadRecs = function () {
        if (recEl.dataset.r24Loaded === 'true') return;
        recEl.dataset.r24Loaded = 'true';
        var fire = function () {
          if (typeof recEl.loadRecommendations === 'function') {
            recEl.loadRecommendations(recEl.dataset.productId);
          }
        };
        if (window.customElements && customElements.whenDefined) {
          customElements.whenDefined('product-recommendations').then(fire);
        } else {
          fire();
        }
      };
      var sentinel = section.parentElement || section;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries, obs) {
            if (!entries[0].isIntersecting) return;
            obs.disconnect();
            loadRecs();
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        io.observe(sentinel);
      } else {
        loadRecs();
      }
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var lines = [];
        var mainForm = document.querySelector('[data-r24-product] product-form form');
        var mainInput = mainForm ? mainForm.querySelector('input[name="id"]') : null;
        if (mainInput && !mainInput.disabled) {
          lines.push({ id: parseInt(mainInput.value, 10), quantity: 1 });
        }
        items().forEach(function (item) {
          if (item.dataset.selected === 'true') {
            lines.push({ id: parseInt(item.dataset.variantId, 10), quantity: 1 });
          }
        });
        if (!lines.length) return;

        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var body = { items: lines };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map(function (s) {
            return s.id;
          });
          body.sections_url = window.location.pathname;
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(addBtn);
        }

        addBtn.disabled = true;
        fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(body),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (response) {
            if (response.status) {
              console.error(response.description || response.message);
              return;
            }
            if (window.publish && window.PUB_SUB_EVENTS) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                cartData: response,
              });
            }
            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(response);
            }
          })
          .catch(function (e) {
            console.error(e);
          })
          .finally(function () {
            addBtn.disabled = false;
          });
      });
    }
  }

  /* ────────────────────────────────────────────────────────────
     6 · Video "EN ACCIÓN" (lite embed)
     El markup solo trae el thumbnail (sección run24-main-product);
     al click se reemplaza por el iframe de youtube-nocookie con
     autoplay — YouTube no pesa nada hasta que el usuario lo pide.
     ──────────────────────────────────────────────────────────── */
  function initVideo() {
    document.querySelectorAll('[data-r24-video]').forEach(function (btn) {
      if (btn.dataset.r24Init === 'true') return;
      btn.dataset.r24Init = 'true';
      btn.addEventListener('click', function () {
        var id = btn.dataset.videoId;
        if (!id) return;
        var frame = document.createElement('div');
        frame.className = 'r24-video__frame';
        var iframe = document.createElement('iframe');
        iframe.src =
          'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1';
        iframe.title = btn.getAttribute('aria-label') || 'Video';
        iframe.setAttribute(
          'allow',
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
        );
        iframe.setAttribute('allowfullscreen', '');
        frame.appendChild(iframe);
        btn.replaceWith(frame);
      });
    });
  }

  function initAll() {
    initProduct();
    initLive();
    initFaq();
    initFavs();
    initCross();
    initVideo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();